import { css } from 'styled-components';

export interface ICardProps {
  padding?: string; // this is used in ip-dash
  disableBoxShadow?: boolean; // used for alerts
  onDismiss?: ((event: React.MouseEvent<HTMLButtonElement>) => void);
}

export const CardStyles = css<ICardProps>`
  position: relative;
  box-shadow: ${({ theme: { card }, disableBoxShadow }) => disableBoxShadow ? 'initial' : card.boxShadow};
  border-radius: ${({ theme: { card } }) => card.borderRadius};
  border: ${({ theme: { card } }) => card.borderWidth} solid ${({ theme: { card } }) => card.colorBorder};
  padding: ${props => props.padding};
  background: ${({ theme: { card } }) => card.colorBackground};
`;
